/*绿色工程*/
let prjConfig = {
   portalType: '18'
};
export default prjConfig